import { resolveBetsInPlace } from "@/features/player/playerHelpers";
import type { Slice } from "@/store/createSlice";
import type { Bet } from "@/types";
import type { ActivityId, BetId, PlayerId } from "@/types/branded";

export const createBettingSlice: Slice<{
  bets: Record<BetId, Bet>;
  placeBet: (bet: Bet) => void;
  resolveBetsForActivity: (activityId: ActivityId, winnerId: PlayerId) => void;
}> = (set, _get) => ({
  bets: {},

  placeBet: (bet) =>
    set(
      (s) => {
        const bettor = s.players[bet.bettorId];
        if (!bettor || bettor.bettingBankroll < bet.wager) return;
        bettor.bettingBankroll -= bet.wager;
        s.bets[bet.id] = bet;
      },
      false,
      "bet/place",
    ),

  resolveBetsForActivity: (activityId, winnerId) =>
    set(
      (s) => {
        resolveBetsInPlace(s.bets, s.players, activityId, [winnerId]);
      },
      false,
      "bet/resolve",
    ),
});
